import type { TelegramWebApp } from '@/types';

export function getTelegramWebApp(): TelegramWebApp | null {
  if (typeof window !== 'undefined' && window.Telegram?.WebApp) {
    return window.Telegram.WebApp;
  }
  return null;
}

export function validateTelegramData(): boolean {
  const webApp = getTelegramWebApp();
  return !!(webApp && webApp.initData);
}

export function getTelegramInitData(): string {
  const webApp = getTelegramWebApp();
  return webApp?.initData || '';
}

export function getTelegramUser() {
  const webApp = getTelegramWebApp();
  return webApp?.initDataUnsafe?.user || null;
}

export function setTelegramTheme() {
  const webApp = getTelegramWebApp();
  if (!webApp) return;

  const root = document.documentElement;
  const theme = webApp.themeParams;

  if (theme.bg_color) root.style.setProperty('--tg-theme-bg-color', theme.bg_color);
  if (theme.text_color) root.style.setProperty('--tg-theme-text-color', theme.text_color);
  if (theme.hint_color) root.style.setProperty('--tg-theme-hint-color', theme.hint_color);
  if (theme.link_color) root.style.setProperty('--tg-theme-link-color', theme.link_color);
  if (theme.button_color) root.style.setProperty('--tg-theme-button-color', theme.button_color);
  if (theme.button_text_color)
    root.style.setProperty('--tg-theme-button-text-color', theme.button_text_color);
  if (theme.secondary_bg_color)
    root.style.setProperty('--tg-theme-secondary-bg-color', theme.secondary_bg_color);
}

export function triggerHaptic(
  type: 'impact' | 'notification' | 'selection',
  style?: 'light' | 'medium' | 'heavy' | 'rigid' | 'soft' | 'error' | 'success' | 'warning'
) {
  const webApp = getTelegramWebApp();
  if (!webApp) return;

  try {
    if (type === 'impact' && style) {
      webApp.HapticFeedback.impactOccurred(style as any);
    } else if (type === 'notification' && style) {
      webApp.HapticFeedback.notificationOccurred(style as any);
    } else if (type === 'selection') {
      webApp.HapticFeedback.selectionChanged();
    }
  } catch (error) {
    // Haptic feedback not supported
  }
}
